import MyAccountChangePlanPromoModal from './MyAccountChangePlanPromoModal'

export default MyAccountChangePlanPromoModal
// eslint-disable-next-line import/export
export * from './MyAccountChangePlanPromoModal'
